const blue = '#4BB3EF';
const white = '#fff';
const black = '#000';
const border = '#DFDFDF';
const red = '#DD2222';
const colorNeutralTitleModal = '#262626';
const colorSubTitleModal = '#5C5E6A';
const grubtechBlue = '#149CEB';

const fadedRed = '#FDE8E8';
const textColor = '#2A3146';
const grayLabel = '#565C6C';
const fadedBlue = 'rgba(75, 179, 239, 0.1)';
const boldBlue = 'rgb(25, 136, 252)';
const lightGray = '#E0E0E0';
const darkGray = '#232323';

export default {
  blue,
  white,
  black,
  border,
  red,
  textColor,
  fadedRed,
  fadedBlue,
  grayLabel,
  boldBlue,
  colorNeutralTitleModal,
  colorSubTitleModal,
  grubtechBlue,
  lightGray,
  darkGray
};
